export default __webpack_public_path__ + "static/media/avatar.e4235ac4.svg";